import { connect } from 'react-redux';
import React, { Component } from 'react';
import ItemDetail from './ItemDetail'
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import * as userActions from '../../../../redux/actions/actionsUser';
import * as inventoryActions from '../../../../redux/actions/inventoryActions'
import { queryStringParse, formatDateForAPI, formatStringForAPI } from '../../../../resources/logic/functions';


const mapStateToProps = store =>
({

    currentUserEmail: store.userServicesReducer.currentUserEmail,
    userSignInData: store.userServicesReducer.userSignInData,

    isCommonUnitOfMeasureGetLoading: store.userServicesReducer.isCommonUnitOfMeasureGetLoading,
    CommonUnitOfMeasureData: store.userServicesReducer.CommonUnitOfMeasureData,

    isCommonUnitOfWeightGetLoading: store.userServicesReducer.isCommonUnitOfWeightGetLoading,
    CommonUnitOfWeightData: store.userServicesReducer.CommonUnitOfWeightData,



    InventoryLotSkuRefPostSuccessful: store.inventoryReducer.InventoryLotSkuRefPostSuccessful,
    isInventoryLotSkuRefLoading: store.inventoryReducer.isInventoryLotSkuRefLoading,

    isInventorySkuRefLoading: store.inventoryReducer.isInventorySkuRefLoading,
    InventorySkuRefData: store.inventoryReducer.InventorySkuRefData,

    isInventoryCustomerRefLoading: store.inventoryReducer.isInventoryCustomerRefLoading,
    InventoryCustomerRefData: store.inventoryReducer.InventoryCustomerRefData,

    isInventoryProjectLoading: store.inventoryReducer.isInventoryProjectLoading,
    InventoryProjectData: store.inventoryReducer.InventoryProjectData,

    isInventoryLotSkuRefHistoryGetLoading: store.inventoryReducer.isInventoryLotSkuRefHistoryGetLoading,
    InventoryLotSkuRefHistoryData: store.inventoryReducer.InventoryLotSkuRefHistoryData,



    isInventoryLotCommonPrimaryUomGetLoading: store.inventoryReducer.isInventoryLotCommonPrimaryUomGetLoading,
    InventoryLotCommonPrimaryUomData: store.inventoryReducer.InventoryLotCommonPrimaryUomData,

    isInventoryLotCommonPackagingUnitGetLoading: store.inventoryReducer.isInventoryLotCommonPackagingUnitGetLoading,
    InventoryLotCommonPackagingUnitData: store.inventoryReducer.InventoryLotCommonPackagingUnitData,


});

const mapDispatchToProps = dispatch =>
({
    inventoryLotSkuRefPost: (_email, _authToken, _WarehouseID, _CustomerID, _SkuID, _SKU, _SkuStatusID, _ProjectID, _Project, _CustomerRefID, _CustomerRef, _Notes, _ProductName, _ProductDetails, _ProductURL, _ProductCountryofOrigin, _HTSCode, _PGAFlag, _TransactionID, _UPC, _PrimUomID, _PackUnitID, _PackingUomQty, _Length, _Width, _Height, _UomID, _Weight, _UowID) => {
        dispatch(inventoryActions.inventoryLotSkuRefPost(_email, _authToken, _WarehouseID, _CustomerID, _SkuID, _SKU, _SkuStatusID, _ProjectID, _Project, _CustomerRefID, _CustomerRef, _Notes, _ProductName, _ProductDetails, _ProductURL, _ProductCountryofOrigin, _HTSCode, _PGAFlag, _TransactionID, _UPC, _PrimUomID, _PackUnitID, _PackingUomQty, _Length, _Width, _Height, _UomID, _Weight, _UowID))
    },

    inventorySkuRefGet: (_email, _authToken, _WarehouseID, _CustomerID, _SkuID, _SKU, _SkuStatusID, _ProjectID, _SkuLotCode, _SkuSerialNumber) => {
        dispatch(inventoryActions.inventorySkuRefGet(_email, _authToken, _WarehouseID, _CustomerID, _SkuID, _SKU, _SkuStatusID, _ProjectID, _SkuLotCode, _SkuSerialNumber))
    },

    inventoryCustomerRefGet: (_email, _authToken, _WarehouseID, _CustomerID) => {
        dispatch(inventoryActions.inventoryCustomerRefGet(_email, _authToken, _WarehouseID, _CustomerID))
    },


    inventoryProjectGet: (_email, _authToken, _WarehouseID, _CustomerID) => {
        dispatch(inventoryActions.inventoryProjectGet(_email, _authToken, _WarehouseID, _CustomerID))
    },

    inventoryLotSkuRefHistoryGet: (_email, _authToken, _WarehouseID, _CustomerID, _SkuID) => {
        dispatch(inventoryActions.inventoryLotSkuRefHistoryGet(_email, _authToken, _WarehouseID, _CustomerID, _SkuID))
    },



    commonUnitOfMeasureGet: (_email, _authToken,) => {
        dispatch(userActions.commonUnitOfMeasureGet(_email, _authToken,))
    },

    commonUnitOfWeightGet: (_email, _authToken,) => {
        dispatch(userActions.commonUnitOfWeightGet(_email, _authToken,))
    },

    inventoryLotCommonPackagingUnitGet: (_email, _authToken,) => {
        dispatch(inventoryActions.inventoryLotCommonPackagingUnitGet(_email, _authToken,))
    },

    inventoryLotCommonPrimaryUomGet: (_email, _authToken,) => {
        dispatch(inventoryActions.inventoryLotCommonPrimaryUomGet(_email, _authToken,))
    },

});

class ItemDetailContainer extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.handleUrlParam();

        this.props.commonUnitOfMeasureGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken)
        this.props.commonUnitOfWeightGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken)
        this.props.inventoryLotCommonPackagingUnitGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken)
        this.props.inventoryLotCommonPrimaryUomGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken)
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.search !== this.props.location.search) {
            this.handleUrlParam();
        }
        if (prevProps.warehouseSelection !== this.props.warehouseSelection) {
            this.handleUrlParam();
        }
        if (prevProps.customerSelection !== this.props.customerSelection) {
            this.handleUrlParam();
        }
        if (prevProps.InventoryLotSkuRefPostSuccessful !== this.props.InventoryLotSkuRefPostSuccessful && this.props.InventoryLotSkuRefPostSuccessful) {
            this.handleUrlParam()
        }
    }



    handleUrlParam = () => {
        const values = queryString.parse(this.props.location.search)

        try {
            var paramSkuID = formatStringForAPI(values.skuid)
        }
        catch (e) {
            var paramSkuID = null
        }

        this.props.inventoryCustomerRefGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection)
        this.props.inventoryProjectGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection)

        this.props.inventorySkuRefGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, paramSkuID, null, null, null, null, null);

        this.props.inventoryLotSkuRefHistoryGet(this.props.currentUserEmail, this.props.userSignInData.AuthToken, this.props.warehouseSelection, this.props.customerSelection, paramSkuID)

    }



    render() {

        return (

            <ItemDetail
                currentUserEmail={this.props.currentUserEmail}
                userSignInData={this.props.userSignInData}
                isMobile={this.props.isMobile}
                warehouseSelection={this.props.warehouseSelection}
                customerSelection={this.props.customerSelection}

                InventoryLotSkuRefPostSuccessful={this.props.InventoryLotSkuRefPostSuccessful}
                isInventoryLotSkuRefLoading={this.props.isInventoryLotSkuRefLoading}
                inventoryLotSkuRefPost={this.props.inventoryLotSkuRefPost}

                inventorySkuRefGet={this.props.inventorySkuRefGet}
                isInventorySkuRefLoading={this.props.isInventorySkuRefLoading}
                InventorySkuRefData={this.props.InventorySkuRefData}

                inventoryCustomerRefGet={this.props.inventoryCustomerRefGet}
                isInventoryCustomerRefLoading={this.props.isInventoryCustomerRefLoading}
                InventoryCustomerRefData={this.props.InventoryCustomerRefData}

                inventoryProjectGet={this.props.inventoryProjectGet}
                isInventoryProjectLoading={this.props.isInventoryProjectLoading}
                InventoryProjectData={this.props.InventoryProjectData}

                isInventoryLotSkuRefHistoryGetLoading={this.props.isInventoryLotSkuRefHistoryGetLoading}
                InventoryLotSkuRefHistoryData={this.props.InventoryLotSkuRefHistoryData}



                isCommonUnitOfMeasureGetLoading={this.props.isCommonUnitOfMeasureGetLoading}
                CommonUnitOfMeasureData={this.props.CommonUnitOfMeasureData}

                isCommonUnitOfWeightGetLoading={this.props.isCommonUnitOfWeightGetLoading}
                CommonUnitOfWeightData={this.props.CommonUnitOfWeightData}

                isInventoryLotCommonPrimaryUomGetLoading={this.props.isInventoryLotCommonPrimaryUomGetLoading}
                InventoryLotCommonPrimaryUomData={this.props.InventoryLotCommonPrimaryUomData}

                isInventoryLotCommonPackagingUnitGetLoading={this.props.isInventoryLotCommonPackagingUnitGetLoading}
                InventoryLotCommonPackagingUnitData={this.props.InventoryLotCommonPackagingUnitData}

            />

        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ItemDetailContainer));



